import clsx from 'clsx';

const RimactTextArea = ({
  customClasses,
  txtAreaValue = '',
  txtAreaPlaceholder = 'Ingresa tu texto...',
  onTxtAreaChange,
  txtAreaName = 'sin descripción',
  txtAreaId,
  txtAreaMaxLength = 500,
}) => {
  return (
    <div className={clsx('rimacTxtArea', customClasses)}>
      <textarea
        className="rimacTxtArea__input"
        value={txtAreaValue}
        placeholder={txtAreaPlaceholder}
        onChange={(e) => onTxtAreaChange(e.target.value)}
        name={txtAreaName}
        id={txtAreaId}
        maxLength={txtAreaMaxLength}
      ></textarea>
      <p className="rimacTxtArea__charNum">{`${txtAreaValue.length}/${txtAreaMaxLength}`}</p>
    </div>
  );
};

export default RimactTextArea;
